// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { textOverflowEllipsis } from "@eisinc/App/SharedStyles/GeneralStyles";
import { navigationDrawerStyles } from "@eisinc/Overrides/Components/NavigationDrawer";
import Close from "@eisinc/XDL/Icons/Close";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    shape: "pill",
    color: "secondary",
    size: 50,
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

navigationDrawerStyles.drawer = {
    size: 300,
    cssOverrides: {
        drawerContent: css`
            margin-top: -2px;
            overflow-x: hidden;
        `,
        drawerTitle: css`
            min-height: 44px;
            padding: 16px;
        `,
    },
    closeButtonIconProps: {
        size: 12,
        src: Close,
    },
    closeButtonProps: {
        css: css`
            width: 12px;
            height: 12px;
            min-height: auto;
            line-height: ${fontConfig.xxSmall.lineHeight};

            ${IconWrapper} {
                inset: auto;
            }
        `,
    },
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        &:first-child {
            margin-top: 0;
            background: ${color("common.ui6")};
        }
    `,
};

navigationDrawerStyles.panelMenu = {
    cssOverrides: {
        wrapper: css`
            & > button {
                padding: 12px 16px;
                height: 48px;
                justify-content: flex-start;

                ${StyledButton} {
                    flex: 1;
                }

                ${TypographyStyle} {
                    display: inline-flex;
                    flex: 1;
                    font-weight: ${fontConfig.weight.regular};
                }

                ${IconWrapper} {
                    width: 22px;
                    height: 22px;
                    color: inherit;
                }
            }
        `,
    },
    parentLinkWrapper: {
        css: css`
            padding: 12px 16px;
            justify-content: flex-start;
        `,
    },
    parentLinkButton: {
        color: "common.ui6",
        typographyProps: {
            forwardAs: "h5",
            lineHeight: "24px",
            weight: fontConfig.weight.medium,
        },
    },
    panelRowProps: {
        css: css`
            font-size: ${fontConfig.xSmall.size}px;
            line-height: ${fontConfig.singleLinexSmall.lineHeight};
            justify-content: flex-start;
            width: 100%;
        `,
    },
};

navigationDrawerStyles.currencySelector = {
    cssOverrides: {
        wrapper: css`
            & > button {
                ${IconWrapper} {
                    width: 22px;
                    height: 22px;
                }
            }
        `,
    },
};

navigationDrawerStyles.panelSectionWrapper = {
    css: css`
        height: 24px;
        display: flex;
        align-items: center;
    `,
};

navigationDrawerStyles.punchOutUserRowWrapper = {
    css: css`
        height: 24px;
        display: flex;
        align-items: center;
    `,
};

navigationDrawerStyles.menuRowIcon = {
    size: 22,
    css: css`
        margin-right: 10px;
        width: 24px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
    `,
};

navigationDrawerStyles.userRowTypography = {
    transform: "uppercase",
    color: "common.background",
    css: css`
        ${textOverflowEllipsis};
    `,
};

navigationDrawerStyles.punchOutUserRowText = {
    transform: "uppercase",
    color: "common.background",
    css: css`
        ${textOverflowEllipsis};
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    color: "common.ui6",
    css: css`
        ${IconWrapper} {
            width: auto;
            height: auto;
        }
    `,
};

navigationDrawerStyles.mainNavigationRowIcon = {
    src: "User",
    color: "common.background",
    size: 22,
    css: css`
        margin-right: 10px;
        width: 24px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
    `,
};

navigationDrawerStyles.punchOutNavigationRowIcon = {
    src: "User",
    color: "common.background",
    size: 22,
    css: css`
        margin-right: 10px;
        width: 24px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
    `,
};

navigationDrawerStyles.mainNavigationRowTypography = {
    transform: "uppercase",
    color: "common.background",
    weight: fontConfig.weight.medium,
};

navigationDrawerStyles.logoLinks = {
    color: "common.accent",
    typographyProps: {
        ellipsis: true,
        transform: "uppercase",
    },
};

navigationDrawerStyles.showInventoryToggle = {};

navigationDrawerStyles.showPricingToggle = {};
